import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/AuthContext";
import Sales from "./components/Sales";
import BDM from "./components/BDM";
import PM from "./components/PM";
import TopLeftMenu from "./components/TopLeftMenu";
import Auth from "./components/Auth";
import SignUp from "./components/signup";
import UserManagement from "./components/UserManagement";
import PmAdmin from "./components/PmAdmin"; // Import PmAdmin
import SalesAdmin from "./components/SalesAdmin"; // Import SalesAdmin
import BdmAdmin from "./components/BdmAdmin"; // Import BdmAdmin

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

const AppContent = () => {
  const { user, logout, loading } = useAuth();

  // Debugging: Log user.department
  console.log("user.department:", user?.department);

  // Show a loading spinner or placeholder while validating the token
  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect users to the correct route based on their department
  const getDefaultRoute = (department) => {
    console.log("Department in getDefaultRoute:", department); // Debugging
  
    // Handle cases where department is undefined, null, or not a string/array
    if (!department) {
      return "/sales"; // Fallback if department is undefined or null
    }
  
    // Extract the first element if department is an array
    const departmentValue = Array.isArray(department) ? department[0] : department;
  
    // Ensure departmentValue is a string
    if (typeof departmentValue !== "string") {
      return "/sales"; // Fallback if departmentValue is not a string
    }
  
    switch (departmentValue.toLowerCase()) {
      case "pm":
        return "/pm";
      case "bdm":
        return "/bdm";
      case "sales":
        return "/sales";
      case "admin":
        return "/user_management";
      default:
        return "/sales"; // Fallback for unknown departments
    }
  };

  return (
    <div>
      {user && (
        <TopLeftMenu
          onLogout={logout}
          userEmail={user.email}
          userDepartment={user.department}
        />
      )}

      <Routes>
        {!user ? (
          <>
            <Route path="/login" element={<Auth />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        ) : (
          <>
            <Route path="/user_management" element={<UserManagement userEmail={user.email} />} />
            <Route path="/sales" element={<Sales userEmail={user.email} />} />
            <Route path="/pm" element={<PM userEmail={user.email} />} />
            <Route path="/bdm" element={<BDM userEmail={user.email} />} />
            <Route path="/pm-admin" element={<PmAdmin userEmail={user.email} />} />
            <Route path="/sales-admin" element={<SalesAdmin userEmail={user.email} />} />
            <Route path="/bdm-admin" element={<BdmAdmin userEmail={user.email} />} />
            {/* Redirect to the default route based on the user's department */}
            <Route path="/" element={<Navigate to={getDefaultRoute(user.department)} />} />
            <Route path="*" element={<Navigate to={getDefaultRoute(user.department)} />} />
          </>
        )}
      </Routes>
    </div>
  );
};
export default App;